<clp-toolbar [title]="'subscription.subscribers.title'"></clp-toolbar>

<div class="px-4 py-3">
  @if (groups$ | async; as groups) {
    <div class="mb-3 grid grid-cols-1 gap-2 sm:grid-cols-3">
      <div class="rounded-lg border border-slate-700 bg-slate-900/55 p-2.5">
        <p class="text-xs uppercase tracking-wide text-slate-400">{{ 'subscription.subscribers.products' | translate }}</p>
        <p class="mt-1 text-xl font-semibold text-slate-100">{{ groups.length }}</p>
      </div>
      <div class="rounded-lg border border-slate-700 bg-slate-900/55 p-2.5">
        <p class="text-xs uppercase tracking-wide text-slate-400">{{ 'subscription.subscribers.totalSubscribers' | translate }}</p>
        <p class="mt-1 text-xl font-semibold text-slate-100">{{ getTotalSubscribers(groups) }}</p>
      </div>
      <div class="rounded-lg border border-slate-700 bg-slate-900/55 p-2.5">
        <p class="text-xs uppercase tracking-wide text-slate-400">{{ 'subscription.subscribers.activeSubscribers' | translate }}</p>
        <p class="mt-1 text-xl font-semibold text-emerald-300">{{ getActiveSubscribers(groups) }}</p>
      </div>
    </div>

    @if (groups.length === 0) {
      <div class="clp-card">
        <div class="clp-card-body flex flex-col items-center gap-2 py-8 text-center">
          <i class="fa-solid fa-users text-2xl text-slate-500"></i>
          <p class="text-sm text-slate-300">{{ 'subscription.subscribers.noSubscribers' | translate }}</p>
          <p class="text-xs text-slate-400">{{ 'subscription.subscribers.noSubscribersDescription' | translate }}</p>
        </div>
      </div>
    } @else {
      <div class="space-y-3">
        @for (group of groups; track group.key) {
          <section class="clp-card">
            <div class="clp-card-body">
              <div class="flex items-center justify-between gap-3">
                <h3 class="text-sm font-semibold text-slate-100">{{ group.productName }}</h3>
                <span class="rounded-full border border-slate-600 bg-slate-800 px-2 py-0.5 text-xs text-slate-200">
                  {{ group.subscribers.length }}
                </span>
              </div>

              <div class="mt-3 overflow-x-auto">
                <table class="w-full min-w-[640px] text-sm">
                  <thead class="text-xs uppercase tracking-wide text-slate-400">
                    <tr>
                      <th class="px-2 py-2 text-left">{{ 'subscription.subscribers.subscriber' | translate }}</th>
                      <th class="px-2 py-2 text-left">{{ 'subscription.subscribers.status' | translate }}</th>
                      <th class="px-2 py-2 text-left">{{ 'subscription.subscribers.since' | translate }}</th>
                      <th class="px-2 py-2 text-left">{{ 'subscription.subscribers.lastPayment' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (subscriber of group.subscribers; track subscriber.key) {
                      <tr class="border-t border-slate-700/70">
                        <td class="px-2 py-2 text-slate-100">
                          {{ subscriber.name || ('subscription.subscribers.unknownSubscriber' | translate) }}
                        </td>
                        <td class="px-2 py-2">
                          <span [class]="getStatusClass(subscriber.status)">
                            {{ getStatusTextKey(subscriber.status) | translate }}
                          </span>
                        </td>
                        <td class="px-2 py-2 text-slate-300">
                          @if (subscriber.subscribedAt) {
                            {{ subscriber.subscribedAt | translocoDate: { dateStyle: 'medium' } }}
                          } @else {
                            -
                          }
                        </td>
                        <td class="px-2 py-2 text-slate-300">
                          @if (subscriber.lastPaymentAt) {
                            <div class="flex flex-col">
                              <span>{{ subscriber.lastPaymentAt | translocoDate: { dateStyle: 'medium' } }}</span>
                              <span class="text-xs text-slate-400">
                                {{ subscriber.amount | translocoCurrency: 'symbol' : { minimumFractionDigits: 2 }: subscriber.currency }}
                              </span>
                            </div>
                          } @else {
                            -
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        }
      </div>
    }
  }
</div>
